import React from 'react'
export default ({ headline, message, selectedUser, isThankYou = false }) => {
  return <div className="email-capture-slider-preview-unsubmitted">
    <div className="email-capture-slider-preview">
      <div className="flex-column flex-1">
        <div className="slider-text">
          <div className="email-capture-text">
            <div className="headline">{headline}</div>
            <div className="message" dangerouslySetInnerHTML={{ __html: message }} />
          </div>
          <div>
            <div className="email-capture-preview-avatar"
              style={{ backgroundImage: `url(${selectedUser.avatarUrl})` }}>
            </div>
          </div>
        </div>
        {!isThankYou && <input type="email" placeholder="name@example.com"/>}
      </div>
    </div>
  </div>
}




// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailCaptureMessage/EmailCaptureSliderPreview.js